export const common = {
  uploadMultipartFile: '/common/upload/multi',
  // HTTP METHOD : POST
  // PARAMETERS : MultipartFile;,
  uploadSingleMultipartFile: '/common/upload',
  // HTTP METHOD : POST
  // PARAMETERS : MultipartFile,
  intro: '/common/intro',
  // HTTP METHOD : POST
  // PARAMETERS : AppVersionRequest, HttpServletResponse,
  getEnumValue: '/common/enum',
  // HTTP METHOD : GET
  // PARAMETERS :
  refreshAccessToken: '/common/refresh/access-token',
  // HTTP METHOD : GET
  // PARAMETERS : RefreshAccessTokenDto, HttpServletResponse,
  download: '/common/download'
  // HTTP METHOD : GET
  // PARAMETERS : fileName,filePath
};

export const adminoperate = {
  updateInquiryAnswer: (inquiryNo) => `/admin/operate/inquiry/${inquiryNo}/answer`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long, InquiryAnswerRegisterRequest,
  getBanner: (bannerNo) => `/admin/operate/banner/${bannerNo}`,
  // HTTP METHOD : GET
  // PARAMETERS : Long,
  deleteInquiry: '/admin/operate/inquiry',
  // HTTP METHOD : DELETE
  // PARAMETERS : SeqListRequest,
  updateMenuOperate: '/admin/operate/menu',
  // HTTP METHOD : PATCH
  // PARAMETERS : MenuOperateDto,
  getBannerList: '/admin/operate/banner',
  // HTTP METHOD : GET
  // PARAMETERS : BannerParameter,
  savePush: '/admin/operate/push',
  // HTTP METHOD : POST
  // PARAMETERS : PushCreateRequest,
  saveBanner: '/admin/operate/banner',
  // HTTP METHOD : POST
  // PARAMETERS : BannerCreateRequest, MultipartFile,
  getMenuOperate: '/admin/operate/menu',
  // HTTP METHOD : GET
  // PARAMETERS :
  deleteBoard: '/admin/operate/board',
  // HTTP METHOD : DELETE
  // PARAMETERS : SeqListRequest,
  saveBoard: '/admin/operate/board',
  // HTTP METHOD : POST
  // PARAMETERS : BoardCreateRequest,
  getInquiry: (inquiryNo) => `/admin/operate/inquiry/${inquiryNo}`,
  // HTTP METHOD : GET
  // PARAMETERS : Long
  getInquiryList: '/admin/operate/inquiry',
  // HTTP METHOD : GET
  // PARAMETERS : InquiryParameter,
  getPushList: '/admin/operate/push',
  // HTTP METHOD : GET
  // PARAMETERS : PushParameter,
  getPush: (pushNo) => `/admin/operate/push/${pushNo}`,
  // HTTP METHOD : GET
  // PARAMETERS : PushParameter,
  deletePush: '/admin/operate/push',
  // HTTP METHOD : DELETE
  // PARAMETERS : SeqListRequest,
  sendPush: (pushNo) => `/admin/operate/push/${pushNo}/send`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long,
  deleteBanner: '/admin/operate/banner',
  // HTTP METHOD : DELETE
  // PARAMETERS : SeqListRequest,
  getBoardList: '/admin/operate/board',
  // HTTP METHOD : GET
  // PARAMETERS : BaseParameter,
  getBoard: (boardNo) => `/admin/operate/board/${boardNo}`
  // HTTP METHOD : GET
  // PathVariable : boardNo,
};

export const adminuser = {
  updateStatus: (authNo) => `/admin/user/${authNo}/status`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long, UserStatusRequest,
  updateResetApplyStatus: (applyNo, applyStatus) => `/admin/user/reset/${applyNo}/${applyStatus}`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long, CommonCode$ApplyStatus,
  updateApproveStatus: (authNo) => `/admin/user/${authNo}/approve`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long, UserApproveRequest,
  updateResetPassword: (authNo) => `/admin/user/${authNo}/reset/password`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long,
  deleteUser: '/admin/user',
  // HTTP METHOD : DELETE
  // PARAMETERS : SeqListRequest,
  getResetApplyList: (resetType) => `/admin/user/reset/${resetType}`,
  // HTTP METHOD : GET
  // PARAMETERS : CommonCode$ResetType, UserParameter,
  updateResetDevice: (authNo) => `/admin/user/${authNo}/reset/device`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long,
  getUser: (authNo) => `/admin/user/${authNo}`,
  // HTTP METHOD : GET
  // PARAMETERS : Long,
  updateFile: (authNo) => `/admin/user/${authNo}/file`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long,
  deleteFile: (fileNo) => `/admin/user/file/${fileNo}`,
  // HTTP METHOD : DELETE
  // PARAMETERS : Long,
  updateResetPhone: (authNo) => `/admin/user/${authNo}/reset/phone`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long,
  getUserList: '/admin/user',
  // HTTP METHOD : GET
  // PARAMETERS : UserParameter,
  updateMemo: (authNo) => `/admin/user/${authNo}/memo`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long,
  updateRemainDay: (authNo) => `/admin/user/${authNo}/remain`
  // HTTP METHOD : PATCH
  // PARAMETERS : Long, RemainDayRequest,
};

export const admin = {
  logout: '/admin/logout',
  // HTTP METHOD : POST
  // PARAMETERS : HttpServletResponse,
  changePassword: '/admin/change-password',
  // HTTP METHOD : PATCH
  // PARAMETERS : AdminChangePasswordRequest,
  login: '/admin/login'
  // HTTP METHOD : PATCH
  // PARAMETERS : AdminLoginRequest, HttpServletResponse,
};

export const adminproduct = {
  getProductList: '/admin/product',
  // HTTP METHOD : GET
  // PARAMETERS : BaseParameter,
  getProduct: (productNo) => `/admin/product/${productNo}`,
  // HTTP METHOD : GET
  // PARAMETERS : Long,
  deleteProduct: '/admin/product',
  // HTTP METHOD : DELETE
  // PARAMETERS : SeqListRequest,
  saveProduct: '/admin/product',
  // HTTP METHOD : POST
  // PARAMETERS : ProductCreateRequest,
  updateProductApplyDeposit: (productApplyNo) => `/admin/product/apply/${productApplyNo}/deposit`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long,
  getProductApplyList: '/admin/product/apply',
  // HTTP METHOD : GET
  // PARAMETERS : UserParameter,
  updateProductApplyStatus: (productApplyNo) => `/admin/product/apply/${productApplyNo}/status`
  // HTTP METHOD : PATCH
  // PARAMETERS : Long, ApplyStatusRequest,
};

export const adminhistory = {
  getHistoryList: (addressBookNo) => `/admin/history/phone/${addressBookNo}/history`,
  // HTTP METHOD : GET
  // PARAMETERS : Long, BaseParameter,
  getReportList: (addressBookNo) => `/admin/history/phone/${addressBookNo}/report`,
  // HTTP METHOD : GET
  // PARAMETERS : Long, BaseParameter,
  saveComplaint: '/admin/history/complaint',
  // HTTP METHOD : POST
  // PARAMETERS : ComplaintCreateRequest,
  deleteHistory: '/admin/history/phone/history',
  // HTTP METHOD : DELETE
  // PARAMETERS : SeqListRequest,
  deleteReport: '/admin/history/phone/report',
  // HTTP METHOD : DELETE
  // PARAMETERS : SeqListRequest,
  getComplaintList: '/admin/history/complaint',
  // HTTP METHOD : GET
  // PARAMETERS : ComplaintParameter,
  deleteComplaint: '/admin/history/complaint',
  // HTTP METHOD : DELETE
  // PARAMETERS : SeqListRequest,
  updateCollectionStatus: (addressBookNo) => `/admin/history/phone/${addressBookNo}/status`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long, AddressBookCollectionStatusRequest,
  getAddressBookByPhone: (phone) => `/admin/history/phone/${phone}`,
  // HTTP METHOD : GET
  // PARAMETERS : String,
  updateComplaintStatus: (complaintNo) => `/admin/history/complaint/${complaintNo}/status`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long, AddressBookCollectionStatusRequest,
  updateComplaintMemo: (complaintNo) => `/admin/history/complaint/${complaintNo}/memo`,
  // HTTP METHOD : PATCH
  // PARAMETERS : Long, String,
  userReportList: '/admin/history/phone/report/user'
  // HTTP METHOD : GET
  // PARAMETERS : BaseParameter
};

//Project Name : null//Created at 2025-01-07 11:12:28
